import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import GrupoPrecificacao from "../../pages/GrupoPrecificacao/GrupoPrecificacao";
import TipoCheckagem from "../../pages/ModuloChecklist/TipoCheckagem/TipoCheckagem";
import Cliente from "../../pages/ModuloGerenciador/Cliente/Cliente";
import GrupoCarga from "../../pages/ModuloGerenciador/GrupoCarga/GrupoCarga";
import GrupoClientes from "../../pages/ModuloGerenciador/GrupoClientes/GrupoClientes";
import MotivoOnTime from "../../pages/ModuloGerenciador/MotivoOnTime/MotivoOnTime";
import Motorista from "../../pages/ModuloGerenciador/Motorista/Motorista";
import Pedido from "../../pages/ModuloGerenciador/Pedido/Pedido";
import Rota from "../../pages/ModuloGerenciador/Rota/Rota";
import Embalagem from "../../pages/ModuloGerenciador/UsoComum/Embalagem/Embalagem";
import EmpresaSubsidiaria from "../../pages/ModuloGerenciador/UsoComum/EmpresaSubsidiaria/EmpresaSubsidiaria";
import Filial from "../../pages/ModuloGerenciador/UsoComum/Filial/Filial";
import MeioPagamento from "../../pages/ModuloGerenciador/UsoComum/MeioPagamento/MeioPagamento";
import Mercadoria from "../../pages/ModuloGerenciador/UsoComum/Mercadoria/Mercadoria";
import Motivo from "../../pages/ModuloGerenciador/UsoComum/Motivo/Motivo";
import MotivoCotacao from "../../pages/ModuloGerenciador/UsoComum/MotivoCotacao/MotivoCotacao";
import MotivoEstadia from "../../pages/ModuloGerenciador/UsoComum/MotivoEstadia/MotivoEstadia";
import Ocorrencia from "../../pages/ModuloGerenciador/UsoComum/Ocorrencia/Ocorrencia";
import Proprietario from "../../pages/ModuloGerenciador/UsoComum/Proprietario/Proprietario";
import SegmentoCliente from "../../pages/ModuloGerenciador/UsoComum/SegmentoCliente/SegmentoCliente";
import Status from "../../pages/ModuloGerenciador/UsoComum/Status/Status";
import StatusDiaria from "../../pages/ModuloGerenciador/UsoComum/StatusDiaria/StatusDiaria";
import SubTipoOcorrencia from "../../pages/ModuloGerenciador/UsoComum/SubTipoOcorrencia/SubTipoOcorrencia";
import TipoCarroceria from "../../pages/ModuloGerenciador/UsoComum/TipoCarroceria/TipoCarroceria";
import TipoOcorrencia from "../../pages/ModuloGerenciador/UsoComum/TipoOcorrencia/TipoOcorrencia";
import TipoVeiculo from "../../pages/ModuloGerenciador/UsoComum/TipoVeiculo/TipoVeiculo";
import UnidadeEmbarque from "../../pages/ModuloGerenciador/UsoComum/UnidadeEmbarque/UnidadeEmbarque";
import Caminhao from "../../pages/ModuloGerenciador/Veiculo/Caminhao/Caminhao";
import Carreta from "../../pages/ModuloGerenciador/Veiculo/Carreta/Carreta";
import Veiculo from "../../pages/ModuloGerenciador/Veiculo/Veiculo/Veiculo";
import TipoRastreamento from "../../pages/ModuloRastreamento/TipoRastreamento/TipoRastreamento";
import ValorEmbarque from "../../pages/ValorEmbarque/ValorEmbarque";
import CloseIcon from "../CloseIcon/CloseIcon";
import "../ModalCadastro/ModalCadastro.css";

export interface SimpleDialogProps {
	titulo?: string;
	tituloBotao?: string;
	tituloConfirmar?: string;
	texto?: string;
	cadastroRota?: string;
	cadastroMotorista?: string;
	cadastroProprietario?: string;
	cadastroCliente?: string;
	cadastroPedido?: string;
	cadastroUnidadeEmbarque?: string;
	cadastroFilial?: string;
	cadastroEmpresaSub?: string;
	cadastroVeiculo?: string;
	cadastroEmbalagem?: string;
	cadastroMercadoria?: string;
	cadastroStatus?: string;
	cadastroMotivo?: string;
	cadastroMeioPagamento?: string;
	cadastroCaminhao?: string;
	cadastroCarreta?: string;
	cadastroTipoCheck?: string;
	cadastroGrupoCliente?: string;
	cadastroGrupoPrecificacao?: string;
	cadastroValorEmbarque?: string;
	cadastroGrupoCarga?: string;
	cadastroMotivoOnTime?: string;
	cadastroMotivoCotacao?: string;
	cadastroSegmentoCliente?: string;
	cadastroOcorrencia?: string;
	cadastroTipoOcorrencia?: string;
	cadastroSubTipoOcorrencia?: string;
	cadastroCarroceria?: string;
	cadastroTipoVeiculo?: string;
	cadastroTipoRastreio?: string;
	cadastroMotivoEstadia?: string;
	cadastroStatusDiaria?: string;
	open: boolean;
	desabilitar?: boolean;
	idAtual?: number;
	onClose: () => void;
	onClick?: () => void;
}

function ModalCadastro(props: SimpleDialogProps) {
	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	const handleClick = () => {
		onClose();
	};

	return (
		<div>
			<Dialog open={open}>
				<div className="div-modal-cadastro">
					<div className="titulo-modal-cadastro">
						<DialogTitle id="alert-dialog-title">
							{!props.desabilitar && <h3>{props.titulo}</h3>}
						</DialogTitle>
						<CloseIcon
							onClick={(e) => {
								handleClose();
							}}
						/>
					</div>
					{props.cadastroRota && (
						<Rota
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMotorista && (
						<Motorista
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroProprietario && (
						<Proprietario
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroCliente && (
						<Cliente
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroPedido && (
						<Pedido
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroUnidadeEmbarque && (
						<UnidadeEmbarque
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroFilial && (
						<Filial
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroEmpresaSub && (
						<EmpresaSubsidiaria
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroVeiculo && (
						<Veiculo
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroEmbalagem && (
						<Embalagem
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMercadoria && (
						<Mercadoria
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroStatus && (
						<Status
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMotivo && (
						<Motivo
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMeioPagamento && (
						<MeioPagamento
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroCaminhao && (
						<Caminhao
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroCarreta && (
						<Carreta
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroTipoCheck && (
						<TipoCheckagem
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroGrupoCliente && (
						<GrupoClientes
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroGrupoPrecificacao && (
						<GrupoPrecificacao
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroValorEmbarque && (
						<ValorEmbarque
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroGrupoCarga && (
						<GrupoCarga
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMotivoOnTime && (
						<MotivoOnTime
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMotivoCotacao && (
						<MotivoCotacao
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroSegmentoCliente && (
						<SegmentoCliente
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroTipoOcorrencia && (
						<TipoOcorrencia
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroSubTipoOcorrencia && (
						<SubTipoOcorrencia
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroOcorrencia && (
						<Ocorrencia
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroCarroceria && (
						<TipoCarroceria
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroTipoVeiculo && (
						<TipoVeiculo
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroTipoRastreio && (
						<TipoRastreamento
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroStatusDiaria && (
						<StatusDiaria
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar
							onCloseModal={handleClose}
						/>
					)}
					{props.cadastroMotivoEstadia && (
						<MotivoEstadia
							botaoVoltar="nao"
							botaoCadastrar="nao"
							telaCadastro={true}
							idAtual={props.idAtual}
							desabilitar={props.desabilitar}
							botaoFechar={false}
							navbar={false}
							onCloseModal={handleClose}
						/>
					)}
				</div>
			</Dialog>
		</div>
	);
}

export default ModalCadastro;
